import { useEffect } from 'react';

import { getProgress, type Progress } from '@/api';
import { BADGE_NAME, computeBadges, type BadgeKey } from '@/badges';
import { readStored, writeStored } from '@/storage';

const KEY = 'badges_seen';

export function seenBadges(): BadgeKey[] | null {
  const raw = readStored(KEY);
  if (raw === null) return null;
  try {
    const arr: unknown = JSON.parse(raw);
    return Array.isArray(arr)
      ? arr.filter((x): x is BadgeKey => typeof x === 'string' && x in BADGE_NAME)
      : [];
  } catch {
    return [];
  }
}

export function takeNewBadges(p: Progress): BadgeKey[] {
  const seen = seenBadges();
  const earned = computeBadges(p)
    .filter((b) => b.earned)
    .map((b) => b.key);

  const next = seen === null ? earned : [...new Set([...seen, ...earned])];
  writeStored(KEY, JSON.stringify(next));

  return seen === null ? [] : earned.filter((k) => !seen.includes(k));
}

export function useSeedBadges(): void {
  useEffect(() => {
    if (seenBadges() !== null) return;

    void getProgress()
      .then(takeNewBadges)
      .catch(() => {});
  }, []);
}
